import { render, staticRenderFns } from "./ApiLookupFormData.vue?vue&type=template&id=a4d502c4&scoped=true&"
import script from "./ApiLookupFormData.vue?vue&type=script&lang=js&"
export * from "./ApiLookupFormData.vue?vue&type=script&lang=js&"
import style0 from "./ApiLookupFormData.vue?vue&type=style&index=0&id=a4d502c4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4d502c4",
  null
  
)

export default component.exports